import { GetAchievementResponseDto, GetAchievementsData, ViewAchievementData } from '@helios/frontend-api-v2-client';
import { requestV2 } from '../';

export const ACHIEVEMENTS_ENDPOINT = '/achievements';

export const getAchievements = async (
  params?: GetAchievementsData['query'],
): Promise<{ data: GetAchievementResponseDto[] }> => {
  const result = await requestV2({
    url: ACHIEVEMENTS_ENDPOINT,
    params,
  });
  return result;
};

export const viewAchievement = async ({
  id,
}: ViewAchievementData['path']): Promise<{ data: GetAchievementResponseDto }> => {
  const result = await requestV2({
    url: `${ACHIEVEMENTS_ENDPOINT}/${id}/view`,
    method: 'POST',
  });
  return result;
};
